import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService, ToastPackage, Toast } from 'ngx-toastr';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-jumpbox-message',
    templateUrl: './jumpbox-message.component.html',
    styleUrls: ['./jumpbox-message.component.scss'],
    animations: [
        trigger('flyInOut', [
            state('inactive', style({ top: 0 })),
            state('active', style({ top: 40 })),
            state('removed', style({ top: 0, opacity: 0 })),
            transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
            transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
        ]),
    ],
    preserveWhitespaces: false,
    standalone: false
})
export class JumpboxMessageComponent  {

  @Output() showToast = new EventEmitter<boolean>();
  @Input() pageName: String
  RouterSegments = RouterSegments;
  tenantId: any;
private destroyRef = inject(DestroyRef);

  constructor(private router: Router, private authService: AuthService, private activatedRoute: ActivatedRoute
  ) {
    
    this.tenantId = this.activatedRoute.snapshot.params.id;
  }

  closeToast(): void {
    this.showToast.emit(false);
  }

  moveToJumpbox(): void {
      this.router.navigate(['/', this.authService.principal.provider, 'tenant', this.tenantId, RouterSegments.JUMPBOX]);
  }

  navigateToSchedule():void{
    localStorage.setItem('filteredScheduleStatus', JSON.stringify(['active']));
    localStorage.setItem('filteredScheduleDate', JSON.stringify(['Next 2 hours']));
    this.router.navigate(['/', this.authService.principal.provider, 'tenant', this.tenantId, RouterSegments.SCHEDULE]);
  }

}
